import { isEmpty, filter, map } from 'lodash';

import { getURL, getSeparator } from '../api/Layers/layer-operations';

import adaptURL from './adapt-url';
import loadCSVFromURL from './load-csv-from-url';

/**
 * Fetches the CSV and returns the two arrays needed for the table.
 *
 * @async
 * @param {string} layer - The csv layer.
 * @returns {object} An object containing the two arrays needed for the table.
 * @throws {Error} If something goes wrong.
 */
const loadCSVTable = async layer => {
  try {
    let tableTitle = [];
    let tableBody = [];
    const url = adaptURL(getURL(layer));
    if (!isEmpty(url)) {
      const rawCSV = await loadCSVFromURL(url);
      const rowArray = rawCSV.split('\n');
      tableTitle = map(rowArray[0].split(getSeparator(layer)), title => title.trim());
      const fullBodyArray = filter(rowArray.slice(1), row => !isEmpty(row));
      tableBody = fullBodyArray.map(row => row.trim().split(getSeparator(layer)));
    }
    return { tableBody, tableTitle };
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadCSVTable;
